import React, { Component } from 'react'
import { connect } from 'react-redux'
import { forIn } from 'lodash'
import copy from 'fast-copy'

import {
	updateTaskOrder,
	updateMilestoneOrder,
	addOrRemoveSubscriber,
	saveTaskStatuses,
	getArchivedData,
	restoreTasks,
	registerHistory,
	toggleCollapseMilestone
} from 'state/actions'

import { getCurrentUser } from 'state/selectors/userSelectors'

import ProjectTasksGantt from './gantt/project-tasks-gantt'
import ProjectTasksList from './list/project-tasks-list'

import { Redirect } from 'react-router'
import isEqual from 'react-fast-compare'
import AiInput from 'components/ai/ai-input'

class ProjectTasks extends Component {
	state = {
		toggleState: 0,
		isDragging: false,
		draggedItemType: null,
		draggedItemId: null,
		isShowingArchived: false,
		isLoadingArchived: false,
		isShowingGanttTasks: true,
	}

	milestonesArray = []

	onDragStart = element => {
		const elementId = parseInt(element.draggableId.replace(/[^0-9]/g, ''))
		const elementType = element.type

		this.setState({
			isDragging: true,
			draggedItemId: elementId,
			draggedItemType: elementType
		})
	}

	generateColumnData = _ => {
		const {
			allStatuses
		} = this.props

		const returnedStatuses = []

		forIn(allStatuses, (status, order) => {
			const newStatus = {
				...status,
				order,
				custom_name: '',
				status_id: status.id
			}

			returnedStatuses.push(newStatus)
		})

		return returnedStatuses
	}

	onDragEnd = result => {
		const {
			currentProject,
			saveTaskStatuses,
			updateTaskOrder,
			allMilestones,
			updateMilestoneOrder,
		} = this.props

		this.setState({
			isDragging: false,
			draggedItemId: null,
			draggedItemType: null
		})

		if (result.type === 'TASK') {
			if (result.destination) {
				const milestoneData = copy(this.milestonesArray)

				const newIndex = result.destination.index

				const oldMilestone = milestoneData.find(milestone => {
					return milestone.id == parseInt(result.source.droppableId.replace('milestone-', ''))
				})

				const newMilestone = milestoneData.find(milestone => {
					return milestone.id == parseInt(result.destination.droppableId.replace('milestone-', ''))
				})

				const task = oldMilestone.tasks.find((task) => {
					return task.id == parseInt(result.draggableId.replace('task-', ''))
				})

				if (!task) {
					return
				}

				// Archived tasks screw with the ordering a bit.
				oldMilestone.tasks = oldMilestone.tasks.filter(task => {
					return !task.deleted_at
				})

				newMilestone.tasks = newMilestone.tasks.filter(task => {
					return !task.deleted_at
				})

				oldMilestone.tasks.splice(oldMilestone.tasks.indexOf(task), 1)
				newMilestone.tasks.splice(newIndex, 0, task)

				oldMilestone.tasks.forEach((task, index) => {
					if (task) {
						task.order = index
					}
				})

				newMilestone.tasks.forEach((task, index) => {
					if (task) {
						task.order = index
					}
				})

				task.milestone_id = newMilestone.id

				updateTaskOrder(milestoneData)
			}
		} else if (result.type === 'STATUS') {
			if (result.destination) {
				const draggableData = result.draggableId.split(' ')

				let statusId = null
				let columnId = null

				draggableData.forEach(data => {
					const splitData = data.split('-')

					const key = splitData[0]
					const value = splitData[1]

					switch (key) {
						case 'column':
							columnId = value
							break
						case 'status':
							statusId = value
							break
					}
				})

				const column = currentProject.columns.find(loopedColumn => {
					return loopedColumn.id == columnId
				})

				if (!column.data || !column.data.length) {
					column.data = this.generateColumnData(column)
				}

				const oldIndex = result.source.index
				const newIndex = result.destination.index

				column.data.sort((a, b) => {
					return a.order - b.order
				})

				const customStatusData = copy(column.data)

				const statusObject = customStatusData.find(status => {
					return status.status_id == statusId
				})

				customStatusData.splice(oldIndex, 1)
				customStatusData.splice(newIndex, 0, statusObject)

				customStatusData.forEach((status, index) => {
					status.order = index
				})

				saveTaskStatuses(currentProject.id, customStatusData, 'order', column)
			}
		} else if (result.type == 'MILESTONE') {
			if (result.destination) {

				let milestoneId = parseInt(result.draggableId.replace('milestone-', ''))
				let oldIndex = result.source.index
				let newIndex = result.destination.index

				let milestoneObjects = []

				currentProject.milestones.forEach(milestoneId => {
					let milestoneObject = allMilestones[milestoneId]

					if (milestoneObject && !milestoneObject.deleted_at) {
						milestoneObjects.push(copy(milestoneObject))
					}
				})

				milestoneObjects.sort((a, b) => {
					return a.project_order - b.project_order
				})

				const thisMilestone = milestoneObjects.find(milestone => {
					return milestone.id === milestoneId
				})

				milestoneObjects.splice(oldIndex, 1)
				milestoneObjects.splice(newIndex, 0, thisMilestone)

				milestoneObjects.forEach((milestoneObject, index) => {
					milestoneObject.project_order = index;
				})

				updateMilestoneOrder(milestoneObjects)
			}
		}
	}

	toggleView = _ => {
		let newToggleState

		if (this.state.toggleState == 0) {
			newToggleState = 1
		} else {
			newToggleState = 0
		}

		this.setState({
			toggleState: newToggleState
		})
	}

	UNSAFE_componentWillMount() {
		const {
			currentProject,
			registerHistory
		} = this.props

		if (currentProject) {
			registerHistory(currentProject.id, 'project', 'tasks')
		}

		this.generateMilestoneArray(this.props, this.state)
	}

	UNSAFE_componentWillUpdate = (nextProps, nextState) => {
		let totalOldTasks = 0
		let totalNewTasks = 0

		this.milestonesArray.forEach(milestone => {
			totalOldTasks += milestone.tasks.length
		})

		this.generateMilestoneArray(nextProps, nextState)

		this.milestonesArray.forEach(milestone => {
			totalNewTasks += milestone.tasks.length
		})

		// in the future, maybe we'll do something about unarchived tasks
		// if this happens during loading, it can fuck everything up.
		if (totalNewTasks && totalOldTasks && (totalNewTasks < totalOldTasks) && !this.state.isShowingArchived && !nextState.isShowingArchived && !nextProps.loading) {
			this.recalculateTaskOrder(this.milestonesArray)
		}
	}

	componentWillUnmount = _ => {
		const {
			setProjectScrollHeight
		} = this.props

		setProjectScrollHeight(window.pageYOffset)
	}

	recalculateTaskOrder = milestoneData => {
		let milestones = copy(milestoneData)

		milestones.forEach((milestone, milestoneIndex) => {
			milestone.tasks.forEach((task, taskIndex) => {
				task.order = taskIndex
			})
		})

		this.props.updateTaskOrder(milestones)
	}

	generateMilestoneArray = (props, state) => {
		const isArchived = state.isShowingArchived

		let milestoneKey = isArchived ? 'archivedMilestones' : 'milestones'
		let tasksKey = isArchived ? 'archivedTasks' : 'tasks'

		const newMilestonesArray = []

		if (!props.currentProject[milestoneKey]) {
			return
		}

		props.currentProject[milestoneKey].forEach(milestoneId => {
			//let clonedMilestone = copy(props.allMilestones[milestoneId])
			const milestone = props.allMilestones[milestoneId]

			if (!milestone) {
				return
			}

			const clonedMilestone = {
				...milestone
			}

			// if we're in archive and the milestone is empty, don't render it.
			if (isArchived && (!clonedMilestone.archivedTasks || !clonedMilestone.archivedTasks.length)) {
				return
			}

			if (!isArchived && clonedMilestone.deleted_at) {
				return
			}

			newMilestonesArray.push(clonedMilestone)
		})

		newMilestonesArray.sort((a, b) => {
			return a.project_order - b.project_order
		})

		newMilestonesArray.forEach(milestone => {
			let milestoneTasks = []

			if (milestone[tasksKey]) {
				milestone[tasksKey].forEach(taskId => {
					const taskObject = props.allTasks[taskId];

					if (taskObject) {
						milestoneTasks.push(props.allTasks[taskId]);
					}
				});
			}

			milestone.tasks = milestoneTasks;

			milestone.tasks.sort((a, b) => {
				return a.order - b.order
			})
		})

		if (!isEqual(newMilestonesArray, this.milestonesArray)) {
			this.milestonesArray = newMilestonesArray
		}
	}

	// annoyingly this can't be moved to -list.jsx, as it's needed in componentWillUpdate
	toggleShowArchived = _ => {
		const isShowingArchived = !this.state.isShowingArchived

		this.setState({
			isLoadingArchived: true
		})

		const newState = {
			isLoadingArchived: false,
			isShowingArchived
		}

		if (isShowingArchived) {
			let hasFinishedLoading = false
			let hasFinishedTimeout = false

			this.props.getArchivedData(this.props.currentProject, _ => {
				hasFinishedLoading = true

				if (hasFinishedTimeout) {
					this.setState(newState)
				}
			})

			setTimeout(_ => {
				hasFinishedTimeout = true

				if (hasFinishedLoading) {
					this.setState(newState)
				}

			}, 200)
		} else {
			setTimeout(_ => {
				this.setState(newState)
			}, 300)
		}
	}

	toggleGantts = _ => {
		const {
			match,
			path,
			history
		} = this.props

		const currentUrl = match.path

		const isGantts = path == 'gantts'

		if (isGantts) {
			history.push(currentUrl.replace('/gantts', '/tasks'))
		} else {
			history.push(currentUrl.replace('/tasks', '/gantts'))
		}
	}

	render() {
		const {
			currentProject,
			loading,
			applicableUsers,
			match,
			isPremium,
			userData,
			toggleCollapseMilestone,
			isArchivedProject,
			path
		} = this.props

		const {
			isShowingArchived,
			isLoadingArchived,
			toggleState,
			isDragging,
			currentFocusedTask,
			draggedItemType,
			draggedItemId,
		} = this.state

		if (!currentProject.milestones) {
			return null
		}

		const isShowingGantts = path == 'gantts'

		if ((!isPremium || !currentProject.has_gantts) && isShowingGantts) {
			return (
				<Redirect to={match.path.replace('/gantts', '/tasks')} />
			)
		}

		return (
			<React.Fragment>
				{
					isShowingGantts ?
						<ProjectTasksGantt
							allTasks={this.props.allTasks}
							milestonesArray={this.milestonesArray}
							currentProject={currentProject}
							toggleState={toggleState}
							toggleView={this.toggleView}
							toggleGantts={this.toggleGantts}
							loading={loading}
							userData={userData}
							toggleCollapseMilestone={toggleCollapseMilestone}
							isArchivedProject={isArchivedProject}
						/>
						:
						<ProjectTasksList
							toggleView={this.toggleView}
							milestonesArray={this.milestonesArray}
							isShowingArchived={isShowingArchived}
							onDragStart={this.onDragStart}
							onDragEnd={this.onDragEnd}
							draggedItemType={draggedItemType}
							draggedItemId={draggedItemId}
							isDragging={isDragging}
							toggleState={toggleState}
							isLoadingArchived={isLoadingArchived}
							loading={loading}
							menuState={this.state}
							handleInputFocus={this.handleInputFocus}
							currentFocusedTask={currentFocusedTask}
							currentProject={currentProject}
							applicableUsers={applicableUsers}
							createMilestone={this.createMilestone}
							toggleShowArchived={this.toggleShowArchived}
							toggleGantts={this.toggleGantts}
							isPremium={isPremium}
							userData={userData}
							toggleCollapseMilestone={toggleCollapseMilestone}
							isArchivedProject={isArchivedProject}
						/>
				}
				{/* <AiInput 
					currentProjectId={currentProject?.id} 
					userData={userData}
				/> */}
			</React.Fragment>
		)
	}
}

const mapStateToProps = state => {
	return {
		allMilestones: state.account.entities.milestones,
		allTasks: state.account.entities.tasks,
		userData: getCurrentUser(state),
		allStatuses: state.account.entities.statuses,
	}
}

export default connect(mapStateToProps, {
	updateTaskOrder,
	updateMilestoneOrder,
	addOrRemoveSubscriber,
	saveTaskStatuses,
	getArchivedData,
	restoreTasks,
	registerHistory,
	toggleCollapseMilestone
})(ProjectTasks)
